import { render, staticRenderFns } from "./NewFollowObservation.vue?vue&type=template&id=ced8a1c8&"
import script from "./NewFollowObservation.vue?vue&type=script&lang=js&"
export * from "./NewFollowObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports